// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";

function Promotion$Group(Props) {
  var children = Props.children;
  return React.createElement("div", {
              className: "w-full flex flex-col space-y-4"
            }, children);
}

var Group = {
  make: Promotion$Group
};

function Promotion$TextExpire(Props) {
  var classNameOpt = Props.className;
  var expireOpt = Props.expire;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var expire = expireOpt !== undefined ? expireOpt : "";
  return React.createElement("div", {
              className: "text-xl font-heading " + className
            }, "ใช้ได้ถึงวันที่ " + expire);
}

var TextExpire = {
  make: Promotion$TextExpire
};

function Promotion$TextCloseRemark(Props) {
  return React.createElement("div", {
              className: "text-sm text-center"
            }, "*หากปิดหน้านี้ คุณสามารถดู Code ส่วนลดนี้อีกครั้งได้ในหน้าข้อมูลส่วนตัว");
}

var TextCloseRemark = {
  make: Promotion$TextCloseRemark
};

var CopyToClipboard = {};

function Promotion(Props) {
  var code = Props.code;
  var img_url = Props.img_url;
  var match = React.useState(function () {
        return false;
      });
  var setCopied = match[1];
  var copied = match[0];
  var cpclass = copied ? "bg-red text-white" : "";
  return React.createElement("div", {
              className: "\n      flex w-full items-center\n      border-2 border-black rounded-2xl\n      px-5\n    ",
              style: {
                height: "95px"
              }
            }, React.createElement("div", {
                  style: {
                    width: "60px"
                  }
                }, React.createElement("div", undefined, React.createElement("img", {
                          style: {
                            height: "70px",
                            width: "60px"
                          },
                          src: img_url
                        }))), React.createElement("div", {
                  className: "flex-grow pl-3 font-heading text-size-h2"
                }, code), React.createElement("div", {
                  className: "w-3/12"
                }, React.createElement(ReactCopyToClipboard.CopyToClipboard, {
                      children: React.createElement("div", {
                            className: "text-size-label border-red border-2 px-2 py-1 rounded-md text-center " + cpclass
                          }, copied ? "Copied" : "Copy"),
                      text: code,
                      onCopy: (function (param) {
                          return Curry._1(setCopied, (function (param) {
                                        return true;
                                      }));
                        })
                    })));
}

var make = Promotion;

export {
  Group ,
  TextExpire ,
  TextCloseRemark ,
  CopyToClipboard ,
  make ,
  
}
/* react Not a pure module */
